import React, { useMemo } from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Establishment } from '../../../../hooks/use-establishments';
import { useTranslation } from 'react-i18next';
import Table from './Table';

export type ArchivedDataEntry = {
	id: number;
	lastNameAndInsertion: string;
	firstName: string;
	initials: string;
	dateOfBirth: string;
	establishment: {
		id: number;
		name: string;
	};
};
type Props = {
	students: ArchivedDataEntry[];
	establishmentData: Establishment[];
};

const columnHelper = createColumnHelper<ArchivedDataEntry>();
const ArchivedOverview = ({ students, establishmentData }: Props) => {
	const { t } = useTranslation();

	const columns = useMemo(
		() => [
			columnHelper.accessor('lastNameAndInsertion', {
				header: t('employees.lastName'),
			}),
			columnHelper.accessor('firstName', {
				header: t('employees.firstName'),
			}),
			columnHelper.accessor('initials', {
				header: t('employees.initials'),
			}),
			columnHelper.accessor('dateOfBirth', {
				header: t('employees.dateOfBirth'),
			}),
			columnHelper.accessor('establishment.name', {
				header: t('employees.establishment'),
			}),
		],
		[],
	);

	return <Table data={students} columns={columns} establishmentData={establishmentData} />;
};

export default ArchivedOverview;
